import { c as _c } from "react/compiler-runtime";
// A seller's own price line, small enough to sit inside a card in the buy drawer.
//
// No axes, labels or interaction: the price printed beside it carries the
// meaning, and this only says which way that price has been moving. Hidden from
// screen readers for the same reason — there is nothing here they cannot already
// read from the price.

import type { PricePoint } from "@/lib/types";
import { buildScales, linePath } from "@/lib/price-history";
const BOX = {
  width: 96,
  height: 28,
  // A stroke centred on the top or bottom edge would clip in half, so the box
  // keeps a hair of padding rather than none.
  padTop: 3,
  padRight: 3,
  padBottom: 3,
  padLeft: 3
};
export function PriceSparkline(t0) {
  const $ = _c(21);
  const {
    points,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  if (points.length < 2) {
    return null;
  }
  let falling;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== className || $[1] !== points) {
    const scales = buildScales(points, BOX);
    const last = points[points.length - 1];
    const first = points[0];
    falling = last.p < first.p;
    t4 = `0 0 ${BOX.width} ${BOX.height}`;
    t5 = `h-7 w-24 overflow-visible ${className}`;
    t6 = "true";
    t7 = "false";
    t8 = <path d={linePath(points, scales)} fill="none" stroke={falling ? "var(--brand)" : "var(--muted-foreground)"} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />;
    t2 = scales.x(last.d);
    t3 = scales.y(last.p);
    $[0] = className;
    $[1] = points;
    $[2] = falling;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    falling = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  const t9 = falling ? "var(--brand)" : "var(--muted-foreground)";
  let t10;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t9) {
    t10 = <circle cx={t2} cy={t3} r={2} fill={t9} />;
    $[10] = t2;
    $[11] = t3;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t11 = <svg viewBox={t4} className={t5} aria-hidden={t6} focusable={t7}>{t8}{t10}</svg>;
    $[14] = t10;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}